import apiClient from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

const authService = {
  // Inscription
  register: async (userData) => {
    try {
      const { firstName, lastName, email, phoneNumber, countryCode, password, role, vendorDetails, userDetails } = userData;
      
      const response = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, {
        firstName,
        lastName,
        email,
        phoneNumber,
        countryCode,
        password,
        role: role || 'user',
        vendorDetails,
        userDetails,
      });

      // Sauvegarder les tokens dans localStorage
      if (response.data?.accessToken && response.data?.refreshToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      } else {
        throw new Error('Les tokens ne sont pas présents dans la réponse');
      }

      return response;
    } catch (error) {
      throw new Error(handleError(error, 'authService.register'));
    }
  },

  // Connexion
  login: async (email, password) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, { email, password });

      // Sauvegarder les tokens dans localStorage
      if (response.data?.accessToken && response.data?.refreshToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      } else {
        throw new Error('Les tokens ne sont pas présents dans la réponse');
      }

      return response;
    } catch (error) {
      throw new Error(handleError(error, 'authService.login'));
    }
  },

  // Déconnexion
  logout: async () => {
    try {
      await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error) {
      // Erreur silencieuse lors de la déconnexion
    } finally {
      // Supprimer les tokens même si la requête échoue
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
  },

  // Rafraîchir le token (géré automatiquement par les intercepteurs, mais gardé pour compatibilité)
  refreshToken: async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken) {
      throw new Error('Aucun refresh token disponible');
    }

    try {
      const response = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });
      
      if (response.data?.accessToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        if (response.data?.refreshToken) {
          localStorage.setItem('refreshToken', response.data.refreshToken);
        }
      }
      
      return response;
    } catch (error) {
      throw new Error(handleError(error, 'authService.refreshToken'));
    }
  },

  // Obtenir le profil de l'utilisateur
  getMe: async () => {
    try {
      return await apiClient.get(API_ENDPOINTS.AUTH.ME);
    } catch (error) {
      throw new Error(handleError(error, 'authService.getMe'));
    }
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  },

  // Obtenir l'utilisateur depuis le localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;

